import { PlusIcon } from '@heroicons/react/24/outline';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { useTranslation } from 'react-i18next';
import LookupFieldConfiguration from './LookupFieldConfiguration';

export default function AddFieldForm({ draftField, handleDraftFieldChange, addField, collections = [] }) {
  const { t } = useTranslation();

  return (
    <div className="rounded-lg border border-gray-200 bg-gray-50 p-4">
      <h3 className="text-sm font-medium text-gray-900 mb-4">{t('customCollections.form.addField.title')}</h3>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-12 items-end">
        <div className="sm:col-span-6">
          <label className="block text-xs font-medium text-gray-700 mb-1">{t('customCollections.form.fieldLabels.name')}</label>
          <input
            type="text"
            name="name"
            value={draftField.name}
            onChange={handleDraftFieldChange}
            placeholder={t('customCollections.form.addField.namePlaceholder')}
            className="block w-full rounded-md bg-white px-3 py-1.5 text-sm text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
          />
        </div>

        <div className="sm:col-span-4">
          <label className="block text-xs font-medium text-gray-700 mb-1">{t('customCollections.form.fieldLabels.type')}</label>
          <div className="grid grid-cols-1">
            <select
              name="type"
              value={draftField.type}
              onChange={handleDraftFieldChange}
              className="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-1.5 pr-8 pl-3 text-sm text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
            >
              <option value="string">{t('customCollections.form.fieldTypes.string')}</option>
              <option value="integer">{t('customCollections.form.fieldTypes.integer')}</option>
              <option value="editor">{t('customCollections.form.fieldTypes.editor')}</option>
              <option value="lookup">{t('customCollections.form.fieldTypes.lookup')}</option>
            </select>
            <ChevronDownIcon
              aria-hidden="true"
              className="pointer-events-none col-start-1 row-start-1 mr-2 size-4 self-center justify-self-end text-gray-400"
            />
          </div>
        </div>
      </div>

      {draftField.type === 'lookup' && (
        <LookupFieldConfiguration
          draftField={draftField}
          handleDraftFieldChange={handleDraftFieldChange}
          collections={collections}
        />
      )}

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-12 items-center mt-4">
        <div className="sm:col-span-2 flex items-center gap-2">
          <input
            type="checkbox"
            name="required"
            checked={!!draftField.required}
            onChange={handleDraftFieldChange}
            className="h-4 w-4 text-indigo-600 focus:ring-indigo-600 border-gray-300 rounded"
          />
          <span className="text-xs font-medium text-gray-700">{t('customCollections.form.fieldFlags.required')}</span>
        </div>

        <div className="sm:col-span-2 flex items-center gap-2">
          <input
            type="checkbox"
            name="filterpresent"
            checked={!!draftField.filterpresent}
            onChange={handleDraftFieldChange}
            className="h-4 w-4 text-indigo-600 focus:ring-indigo-600 border-gray-300 rounded"
          />
          <span className="text-xs font-medium text-gray-700">{t('customCollections.form.fieldFlags.filterable')}</span>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-12 mt-4">
        <div className="sm:col-span-3">
          <button
            type="button"
            onClick={addField}
            className="w-full flex items-center justify-center gap-2 rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            <PlusIcon className="h-4 w-4" />
            {t('customCollections.form.addField.action')}
          </button>
        </div>
      </div>
    </div>
  );
}
